import { createMetaInfoObject } from '~/lib'
import type { Product, Category } from '~/types/shopware'

export const useShopwareMetaTags = (entity: Product | Category) => {
  // Strip HTML tags from descriptions for meta tags
  const stripHtml = (text?: string | null) => text?.replace(/<[^>]*>?/g, '') || undefined

  const metaDescription = stripHtml(
    entity.translated.metaDescription ? entity.translated.metaDescription : entity.translated.description,
  )

  useSeoMeta(
    createMetaInfoObject([
      ['title', `${entity.translated.metaTitle ? entity.translated.metaTitle : entity.translated.name} | Careum`],
      ['description', metaDescription],
      ['og:title', entity.translated.metaTitle ? entity.translated.metaTitle : entity.translated.name],
      ['og:description', metaDescription],
      ['robots', 'index, follow'],
    ]),
  )
}
